
function buildUrl(relative_path){
    return process.env.REACT_APP_API_URL + relative_path;
}

export {buildUrl}